export default __webpack_public_path__ + "static/media/weapon2.0d038928.png";